(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveals al hacer scroll: un solo observer compartido */
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('mt-visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 }) : null;

  function initReveals() {
    document.querySelectorAll('.mt-reveal').forEach(function (el) {
      if (el.dataset.mtObs) return;
      el.dataset.mtObs = '1';
      if (!observer || reducir) { el.classList.add('mt-visible'); return; }
      observer.observe(el);
    });
  }

  /* Héroe: la imagen se asienta (zoom-out) y el texto entra después */
  function initHero() {
    document.querySelectorAll('[data-mt-hero]').forEach(function (hero) {
      if (hero.dataset.mtInit) return;
      hero.dataset.mtInit = '1';
      var img = hero.querySelector('.mt-he__media img');
      function listo() { requestAnimationFrame(function () { hero.classList.add('mt-listo'); }); }
      if (!img || img.complete) listo(); else { img.addEventListener('load', listo); setTimeout(listo, 1200); }
    });
  }

  /* Antes / después: el deslizador mueve la línea */
  function initAntesDespues() {
    document.querySelectorAll('[data-mt-ad]').forEach(function (marco) {
      if (marco.dataset.mtInit) return;
      marco.dataset.mtInit = '1';
      var rango = marco.querySelector('.mt-ad__rango');
      if (!rango) return;
      function mover() { marco.style.setProperty('--pos', rango.value + '%'); }
      rango.addEventListener('input', mover);
      mover();
    });
  }

  /* Pasos con pestañas: clic o avance automático con barra de progreso */
  function initPasos() {
    document.querySelectorAll('[data-mt-pasos]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-mt-tab]'));
      var escenas = sec.querySelectorAll('[data-mt-escena]');
      if (!tabs.length) return;
      var auto = sec.dataset.mtAuto === 'true' && !reducir;
      var actual = 0, visible = false, parado = false;
      function activar(i, manual) {
        actual = i;
        tabs.forEach(function (t, j) {
          t.setAttribute('aria-selected', j === i ? 'true' : 'false');
          var barra = t.querySelector('.mt-pa__barra');
          if (barra) { barra.classList.remove('mt-corre'); void barra.offsetWidth; if (j === i && auto && !parado && visible) barra.classList.add('mt-corre'); }
        });
        escenas.forEach(function (img, j) { img.classList.toggle('mt-activa', j === i); });
        if (manual) parado = true;
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activar(i, true); });
        var barra = t.querySelector('.mt-pa__barra');
        if (barra) barra.addEventListener('animationend', function () { if (!parado) activar((actual + 1) % tabs.length); });
      });
      sec.addEventListener('keydown', function (ev) {
        if (ev.key !== 'ArrowDown' && ev.key !== 'ArrowUp') return;
        ev.preventDefault();
        var n = (actual + (ev.key === 'ArrowDown' ? 1 : -1) + tabs.length) % tabs.length;
        activar(n, true); tabs[n].focus();
      });
      if (auto && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          visible = e[0].isIntersecting;
          if (visible) activar(actual);
        }, { threshold: 0.4 }).observe(sec);
      }
    });
  }

  /* FAQ: abre y cierra con animación */
  function initFaq() {
    document.querySelectorAll('[data-mt-faq]').forEach(function (lista) {
      if (lista.dataset.mtInit) return;
      lista.dataset.mtInit = '1';
      lista.querySelectorAll('.mt-fq__pregunta').forEach(function (b) {
        b.addEventListener('click', function () {
          b.setAttribute('aria-expanded', b.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
        });
      });
    });
  }

  /* Página de producto: galería + variantes */
  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var principal = sec.querySelector('[data-mt-principal]');
      var minis = sec.querySelectorAll('[data-mt-mini]');
      function verFoto(src, boton) {
        if (!principal || !src) return;
        principal.src = src;
        minis.forEach(function (m) { m.setAttribute('aria-current', m === boton ? 'true' : 'false'); });
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { verFoto(m.dataset.mtMini, m); }); });

      var datos = sec.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var form = sec.querySelector('form[action*="/cart/add"]');
      var input = form && form.querySelector('input[name="id"]');
      var boton = form && form.querySelector('[type="submit"]');
      var precio = sec.querySelector('[data-mt-precio]');
      var tachado = sec.querySelector('[data-mt-tachado]');
      var formato = sec.dataset.mtFormato || '';
      function dinero(cents) {
        var v = (cents / 100).toFixed(2);
        return formato.indexOf('{{') > -1 ? formato.replace(/\{\{\s*[a-z_]+\s*\}\}/, v.replace('.', ',')) : v;
      }
      sec.querySelectorAll('[data-mt-opcion]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var elegidas = [];
          sec.querySelectorAll('[data-mt-opcion]:checked').forEach(function (r) { elegidas[+r.dataset.mtOpcion] = r.value; });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
          if (!v) { if (boton) { boton.disabled = true; boton.textContent = boton.dataset.noDisponible; } return; }
          if (input) input.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (tachado) { tachado.hidden = !(v.compare_at_price > v.price); tachado.textContent = v.compare_at_price ? dinero(v.compare_at_price) : ''; }
          if (boton) { boton.disabled = !v.available; boton.textContent = v.available ? boton.dataset.texto : boton.dataset.agotado; }
          if (v.featured_image && v.featured_image.src) {
            var m = Array.prototype.find.call(minis, function (b) { return b.dataset.mtId == v.featured_image.id; });
            verFoto(m ? m.dataset.mtMini : v.featured_image.src, m);
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  /* Carrusel de opiniones: flechas + avance automático con pausa */
  function initResenas() {
    document.querySelectorAll('[data-mt-resenas]').forEach(function (pista) {
      if (pista.dataset.mtInit) return;
      pista.dataset.mtInit = '1';
      var sec = pista.closest('.mt-re');
      function paso() { var t = pista.querySelector('.mt-re__tarjeta'); return t ? t.getBoundingClientRect().width + 20 : pista.clientWidth; }
      function mover(dir) {
        var fin = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 4;
        if (dir > 0 && fin) pista.scrollTo({ left: 0 }); else pista.scrollBy({ left: dir * paso() });
      }
      var ant = sec && sec.querySelector('[data-mt-re-ant]'), sig = sec && sec.querySelector('[data-mt-re-sig]');
      if (ant) ant.addEventListener('click', function () { mover(-1); });
      if (sig) sig.addEventListener('click', function () { mover(1); });
      if (pista.dataset.mtAuto !== 'true' || reducir) return;
      var pausa = false, visible = false;
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) { pista.addEventListener(ev, function () { pausa = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function (ev) { pista.addEventListener(ev, function () { pausa = false; }); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.3 }).observe(pista);
      setInterval(function () { if (visible && !pausa && !document.hidden) mover(1); }, (+pista.dataset.mtSegundos || 6) * 1000);
    });
  }

  function initTodo() { initReveals(); initHero(); initAntesDespues(); initPasos(); initFaq(); initResenas(); initProducto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
